import api from '../../api';

const schoolService = {
  async getSchoolReport(schoolId) {
    try {
      const response = await api.get(`/schools/${schoolId}/report`);
      return response.data;
    } catch (error) {
      console.error('Error fetching school report:', error);
      throw error;
    }
  },
  
  async getSchoolSummary(schoolId) {
    try {
      const response = await api.get(`/schools/${schoolId}/summary`);
      return response.data;
    } catch (error) {
      console.error('Error fetching school summary:', error);
      throw error;
    }
  },

  async getSchoolStudents(schoolId) {
    try {
      const response = await api.get(`/schools/${schoolId}/students`);
      return response.data;
    } catch (error) {
      console.error('Error fetching school students:', error);
      throw error;
    }
  },

  async getSchoolStaff(schoolId) {
    try {
      const response = await api.get(`/schools/${schoolId}/staff`);
      return response.data;
    } catch (error) {
      console.error('Error fetching school staff:', error);
      throw error;
    }
  },

  async getSchoolPerformance(schoolId) {
    try {
      const response = await api.get(`/schools/${schoolId}/performance`);
      return response.data;
    } catch (error) {
      console.error('Error fetching school performance:', error);
      throw error;
    }
  },

  async updateSchoolDetails(schoolId, details) {
    try {
      const response = await api.put(`/schools/${schoolId}`, details);
      return response.data;
    } catch (error) {
      console.error('Error updating school details:', error);
      throw error;
    }
  }
};

export { schoolService };
